!function(angular) {
    "use strict";

    var clockService = angular.module('service.Clock', []);

clockService.factory('clockService', ['$http', 'halClient', 'appSettings', 'localStorageService', 'storageKeys',
    function($http, halClient, appSettings, localStorageService, storageKeys){

            var storeTimeUrl = appSettings.apiBaseUri + "/store/time/";
            var store = localStorageService.get(storageKeys.storeKey);

            var appDateTimeFormatUrl = appSettings.apiBaseUri + "/user/appDateFormat";

            return {
                getTimeZone: function () {
                    return store.timeZone;
                },
                getTime: function (storeId) {
                    var storeIdString = storeId ? storeId.toString() : localStorageService.get(storageKeys.storeKey).id.toString();
                    return halClient.$get(storeTimeUrl + storeIdString);
                },
                getAppDateFormat: function () {
                    var dataTimeFormat = halClient.$get(appDateTimeFormatUrl);
                    return dataTimeFormat;
                },
                // Inverse of getStringFromTime() function
                // This function strips the time zone component from a string and returns a new local date object
                // that assumes the time zone is the current, client side time zone. This is necessary as data
                // returned by the Vegas APIs is not completely sanitized, however, it is in the correct time zone for the
                // store. Data on the client-side should always be treated to be in the store's chosen time zone, regardless
                // of what the browser indicates the time to be.
                getTimeFromString: function (isoString) {
                    var dateRegex = /(\d+)-(\d+)-(\d+)/;
                    var timeRegex = /(\d+):(\d+):(\d+)/;

                    var date = dateRegex.exec(isoString);
                    var time = timeRegex.exec(isoString);

                    var year = date[1];
                    var month = parseInt(date[2]) - 1;
                    var day = date[3];

                    var hour = time[1];
                    var minute = time[2];
                    var second = time[3];

                    return new Date(year, month, day, hour, minute, second);
                },
                roundedUpDate: function (inputDate) {
                    if (inputDate == null) {
                        return inputDate;
                    }
                    var date = new Date(inputDate.getTime());
                    // Round time up to nearest minute to stop second differences from throwing minDate/maxDate errors
                    if (date.getSeconds() !== 0) {
                        date.setSeconds(0);
                        date.setMinutes(date.getMinutes() + 1);
                    }
                    return date;
                },
                roundedDownDate: function (inputDate) {
                    if (inputDate == null) {
                        return inputDate;
                    }
                    var date = new Date(inputDate.getTime());
                    date.setSeconds(0);
                    return date;
                },

                // Inverse of getTimeFromString() function
                // This function strips the local time information from a string before sending it to the server. This is
                // necessary because time sent to the server needs to be interpreted as being in the store's time zone,
                // regardless of where the client's browser appears to be.
                getStringFromTime: function (jsDateObject) {
                    function padDateString(number) {
                        return number < 10 ? "0" + number.toString() : number.toString();
                    }

                    // Year starts at 1900 on js Date
                    var year = padDateString(jsDateObject.getYear() + 1900);
                    // Months start on 0 on js Date
                    var month = padDateString(jsDateObject.getMonth() + 1);

                    var day = padDateString(jsDateObject.getDate());

                    var hour = padDateString(jsDateObject.getHours());
                    var minute = padDateString(jsDateObject.getMinutes());
                    var second = padDateString(jsDateObject.getSeconds());

                    var date = year + "-" + month + "-" + day;
                    var time = hour + ":" + minute + ":" + second;

                    return date + "T" + time;
                }
            };
        }
    ]);
}(angular);